import ListAtmPayroll from "./ListAtmPayroll";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getATMData } from "../../../../../store/Api";

export default function AtmPayRollUpdate() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.atmData);

  // // API CALL
  // useEffect(() => {
  //   dispatch(getATMData(token));
  // }, []);

  // // CallBack
  // const updateData = () => {
  //   dispatch(getATMData(token));
  // };

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  //Get Token
  const token = localStorage.getItem("nodeToken");

  // const [filterData,set]

  return (
    <>
      <ListAtmPayroll
        // list={data?.data}
        loading={loading}
        titles={[
          "S.NO.",
          "EMPLOYEE ID",
          "EMPLOYEE NAME",
          "CLIENT",
          "VISA PROVIDER",
          "IQAMA NUMBER",
          "EMPLOYEE KSA CONTACT NUMBER",
          "ACCOUNT TO BE OPENED BY",
          "Action",
        ]}
        token={token}
        // updateData={updateData}
        uploadFile={setShowPromptElement}
      />
    </>
  );
}
